import React from 'react';
import useDimensions from 'react-cool-dimensions';

interface ConfigurableGridItemProps {
  children: React.ReactNode;
  onResizeFunction: (height: number) => void;
}

const ConfigurableGridItem = ({ onResizeFunction, children }: ConfigurableGridItemProps) => {
  const { observe } = useDimensions<HTMLDivElement>({
    onResize: ({ height }: { height: number }) => {
      // Triggered whenever the size of the target is changed
      if (onResizeFunction !== undefined) {
        onResizeFunction(height);
      }
    }
  });

  return (
    <div
      ref={el => {
        observe(el || undefined); // Set the target element for measuring
      }}
    >
      {children}
    </div>
  );
};

export default ConfigurableGridItem;
